<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <div v-else>
            <!-- Summary Cards Block -->
            <b-row class="mb-2">
                <b-col sm="6" md class="mb-3">
                    <b-card
                        class="shadow-sm"
                        style="border-left: 4px solid #73818f; height: 100%;"
                    >
                        <div
                            class="text-muted small text-uppercase font-weight-bold"
                        >
                            Total Deposit
                        </div>
                        <div class="h3 font-weight-bold my-2 text-dark">
                            Rp.
                            {{ $helper.formatThousand(summary.total.amount) }}
                        </div>
                        <span class="badge badge-secondary"
                            >{{ summary.total.count }} Transaksi</span
                        >
                    </b-card>
                </b-col>
                <b-col sm="6" md class="mb-3">
                    <b-card
                        class="shadow-sm"
                        style="border-left: 4px solid #73818f; height: 100%;"
                    >
                        <div
                            class="text-muted small text-uppercase font-weight-bold"
                        >
                            DP TERBAYAR
                        </div>
                        <div class="h3 font-weight-bold my-2 text-dark">
                            Rp.
                            {{
                                $helper.formatThousand(
                                    summary.awaiting_attendance.amount
                                )
                            }}
                        </div>
                        <span class="badge badge-secondary"
                            >{{
                                summary.awaiting_attendance.count
                            }}
                            Transaksi</span
                        >
                    </b-card>
                </b-col>
                <b-col sm="6" md class="mb-3">
                    <b-card
                        class="shadow-sm"
                        style="border-left: 4px solid #73818f; height: 100%;"
                    >
                        <div
                            class="text-muted small text-uppercase font-weight-bold"
                        >
                            SETTLEMENT (Diselesaikan)
                        </div>
                        <div class="h3 font-weight-bold my-2 text-dark">
                            Rp.
                            {{
                                $helper.formatThousand(
                                    summary.settled_to_customer.amount
                                )
                            }}
                        </div>
                        <span class="badge badge-secondary"
                            >{{
                                summary.settled_to_customer.count
                            }}
                            Transaksi</span
                        >
                    </b-card>
                </b-col>
                <b-col sm="6" md class="mb-3">
                    <b-card
                        class="shadow-sm"
                        style="border-left: 4px solid #73818f; height: 100%;"
                    >
                        <div
                            class="text-muted small text-uppercase font-weight-bold"
                        >
                            CSR (Didonasikan)
                        </div>
                        <div class="h3 font-weight-bold my-2 text-dark">
                            Rp.
                            {{
                                $helper.formatThousand(
                                    summary.donated_to_charity.amount
                                )
                            }}
                        </div>
                        <span class="badge badge-secondary"
                            >{{
                                summary.donated_to_charity.count
                            }}
                            Transaksi</span
                        >
                    </b-card>
                </b-col>
                <b-col sm="6" md class="mb-3">
                    <b-card
                        class="shadow-sm"
                        style="border-left: 4px solid #73818f; height: 100%;"
                    >
                        <div
                            class="text-muted small text-uppercase font-weight-bold"
                        >
                            REFUND (Dikembalikan)
                        </div>
                        <div class="h3 font-weight-bold my-2 text-dark">
                            Rp.
                            {{
                                $helper.formatThousand(summary.refunded.amount)
                            }}
                        </div>
                        <span class="badge badge-secondary">
                            {{ summary.refunded.count }}
                            Transaksi</span
                        >
                    </b-card>
                </b-col>
            </b-row>

            <!-- Filters Block -->
            <b-card>
                <h5 class="mb-0">
                    <i class="fa fa-fw fa-money mr-2" />Deposit Konser
                </h5>
                <hr />
                <div class="d-flex flex-wrap" style="margin: -8px;">
                    <div class="p-2" style="flex: 1 1 200px; min-width: 200px;">
                        <b-form-group label="Konser" class="mb-0">
                            <multiselect
                                v-model="filter.concert"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                placeholder="Semua konser"
                                :options="optConcerts"
                            />
                        </b-form-group>
                    </div>
                    <div class="p-2" style="flex: 1 1 200px; min-width: 200px;">
                        <b-form-group label="Status" class="mb-0">
                            <b-form-select
                                v-model="filter.destination"
                                :options="optDestinations"
                            />
                        </b-form-group>
                    </div>
                    <div class="p-2" style="flex: 1 1 200px; min-width: 200px;">
                        <b-form-group label="Customer" class="mb-0">
                            <multiselect
                                v-model="filter.customer"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                placeholder="Semua customer"
                                :options="optCustomer"
                            />
                        </b-form-group>
                    </div>
                    <div class="p-2" style="flex: 2 1 300px; min-width: 280px;">
                        <b-form-group
                            label="Tanggal Bayar (Range)"
                            class="mb-0"
                        >
                            <div
                                class="d-flex flex-column flex-sm-row align-items-sm-center"
                            >
                                <b-form-input
                                    v-model="filter.start"
                                    type="date"
                                    class="mb-2 mb-sm-0 mr-sm-2"
                                />
                                <span
                                    class="mb-2 mb-sm-0 mr-sm-2 text-center text-sm-left"
                                    >s/d</span
                                >
                                <b-form-input
                                    v-model="filter.end"
                                    type="date"
                                />
                            </div>
                        </b-form-group>
                    </div>
                </div>
                <div class="text-right my-3">
                    <b-button
                        variant="primary"
                        class="mr-2"
                        @click="getItems()"
                    >
                        <i class="fa fa-search mr-2" />Cari
                    </b-button>
                    <b-button variant="danger" @click="resetFilter">
                        Reset
                    </b-button>
                </div>

                <!-- Table -->
                <b-table
                    bordered
                    hover
                    show-empty
                    no-local-sorting
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    responsive
                    class="mb-3"
                >
                    <template v-slot:empty>
                        Tidak ada data transaksi deposit.
                    </template>
                    <template v-slot:cell(concert)="row">
                        <div v-if="row.item.concert && row.item.concert.id">
                            <span class="font-weight-bold">{{
                                row.item.concert.name
                            }}</span>
                            <span class="d-block small">{{
                                $helper.parseDate(row.item.concert.date)
                            }}</span>
                        </div>
                        <span v-else>-</span>
                    </template>
                    <template v-slot:cell(customer)="row">
                        <div>
                            <span class="font-weight-bold">{{
                                row.item.customer.name
                            }}</span>
                            <span
                                class="d-block small"
                                v-if="row.item.customer.phone"
                            >
                                {{ row.item.customer.phone }}
                            </span>
                        </div>
                    </template>
                    <template v-slot:cell(amount)="row">
                        <div>
                            Rp. {{ $helper.formatThousand(row.item.amount) }}
                            <span class="d-block small text-muted">
                                {{ row.item.slot_count }} slot
                            </span>
                            <div v-if="row.item.refund" class="small text-danger mt-1">
                                Rp. {{ $helper.formatThousand(row.item.refund.amount) }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell(paid_at)="row">
                        <span>
                            {{ $helper.parseDate(row.item.paid_at) }}<br />
                            {{ $helper.parseHourMinute(row.item.paid_at) }}
                        </span>
                    </template>
                    <template v-slot:cell(destination)="row">
                        <b-badge
                            v-for="d in row.item.destinations"
                            :key="d.value"
                            :variant="getDestinationBadge({ destination: d.value, refund: row.item.refund }).variant"
                            class="text-uppercase mr-1 mb-1"
                        >
                            {{ getDestinationBadge({ destination: d.value, refund: row.item.refund }).label }}
                        </b-badge>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="d-flex align-items-center justify-content-center">
                            <b-button
                                size="sm"
                                variant="outline-secondary"
                                class="mr-1"
                                v-b-tooltip.hover.top
                                :title="row.detailsShowing ? 'Tutup slot' : 'Lihat slot'"
                                @click="row.toggleDetails"
                            >
                                <i
                                    class="fa fa-fw"
                                    :class="row.detailsShowing ? 'fa-chevron-up' : 'fa-chevron-down'"
                                />
                            </b-button>
                            <router-link
                                v-if="row.item.submission_id"
                                :to="
                                    `/konser-penjualan/deposit/submission/${row.item.submission_id}`
                                "
                                class="mr-1"
                            >
                                <b-button
                                    size="sm"
                                    variant="primary"
                                    v-b-tooltip.hover.top
                                    title="Detail Peserta"
                                >
                                    <i class="fa fa-fw fa-user" />
                                </b-button>
                            </router-link>
                            <b-button
                                v-if="isCancelable(row.item)"
                                size="sm"
                                variant="danger"
                                v-b-tooltip.hover.top
                                title="Batalkan DP (semua slot)"
                                @click="cancelDp(row.item)"
                            >
                                <i class="fa fa-fw fa-times" />
                            </b-button>
                        </div>
                    </template>

                    <template v-slot:row-details="row">
                        <div class="p-2 bg-light rounded">
                            <b-table-simple small borderless class="mb-0">
                                <b-thead>
                                    <b-tr class="small text-muted">
                                        <b-th>Slot</b-th>
                                        <b-th>Nominal</b-th>
                                        <b-th>Kehadiran</b-th>
                                        <b-th>Target</b-th>
                                        <b-th class="text-center">Status</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr
                                        v-for="slot in row.item.slots"
                                        :key="slot.id"
                                    >
                                        <b-td>Slot {{ slot.slot_no }}</b-td>
                                        <b-td>Rp. {{ $helper.formatThousand(slot.amount) }}</b-td>
                                        <b-td>
                                            <b-badge
                                                :variant="getAttendanceBadgeVariant(slot.attendance_status)"
                                                class="text-uppercase"
                                            >
                                                {{ slot.attendance_status_label || "BELUM DITANDAI" }}
                                            </b-badge>
                                        </b-td>
                                        <b-td>
                                            <b-badge
                                                v-if="slot.achievement_status_label"
                                                variant="info"
                                                class="text-uppercase"
                                            >
                                                {{ slot.achievement_status_label }}
                                            </b-badge>
                                            <span v-else class="text-muted small">-</span>
                                        </b-td>
                                        <b-td class="text-center">
                                            <b-badge
                                                :variant="getDestinationBadge({ destination: slot.destination, refund: row.item.refund }).variant"
                                                class="text-uppercase"
                                            >
                                                {{ getDestinationBadge({ destination: slot.destination, refund: row.item.refund }).label }}
                                            </b-badge>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </div>
                    </template>
                </b-table>

                <!-- Pagination -->
                <PageSizer
                    :totalRows="totalRows"
                    :page="currentPage"
                    :options="options"
                    @limit-change="onLimitChange"
                    @page-change="onPageChange"
                />
            </b-card>
        </div>
    </div>
</template>

<script>
import { DEPOSIT_DESTINATION, ATTENDANCE_STATUS, REFUND_STATUS } from "../konserHelper";

export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,

            summary: {
                total: { amount: 0, count: 0 },
                settled_to_customer: { amount: 0, count: 0 },
                donated_to_charity: { amount: 0, count: 0 },
                awaiting_attendance: { amount: 0, count: 0 },
                refunded: { amount: 0, count: 0 }
            },

            filter: {
                concert: null,
                destination: -1,
                customer: null,
                start: "",
                end: ""
            },

            optConcerts: [],
            optCustomer: [],
            optDestinations: [
                { value: -1, text: "Semua Status" },
                {
                    value: DEPOSIT_DESTINATION.AWAITING,
                    text: "DP TERBAYAR"
                },
                {
                    value: DEPOSIT_DESTINATION.SETTLED,
                    text: "SETTLEMENT (Diselesaikan)"
                },
                {
                    value: DEPOSIT_DESTINATION.DONATED,
                    text: "CSR (Didonasikan)"
                },
                {
                    value: DEPOSIT_DESTINATION.REFUNDED,
                    text: "REFUND (Dikembalikan)"
                }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                {
                    key: "invoice_number",
                    label: "Nomor Invoice",
                    sortable: false
                },
                { key: "concert", label: "Konser", sortable: false },
                { key: "customer", label: "Customer", sortable: false },
                {
                    key: "amount",
                    label: "Nominal DP",
                    sortable: false
                },
                { key: "paid_at", label: "Tanggal Bayar", sortable: false },
                {
                    key: "destination",
                    label: "Status",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center"
                },
                {
                    key: "action",
                    label: "Aksi",
                    tdClass: "text-center",
                    thClass: "text-center"
                }
            ],

            items: []
        };
    },

    methods: {
        init() {
            this.initStatus = 0;

            let getConcerts = this.getConcerts();
            let getCustomers = this.getCustomers();
            let getItems = this.getItems();

            Promise.all([getItems, getConcerts, getCustomers])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => {
                    this.initStatus = -1;
                });
        },

        getConcerts() {
            return this.$axios.get("concerts/selection").then(res => {
                this.optConcerts = (res.data.data || []).map(item => {
                    return {
                        id: item.id,
                        name: item.date
                            ? `${item.name} (${this.$helper.parseDate(item.date)})`
                            : item.name
                    };
                });
            });
        },

        getCustomers() {
            return this.$axios.get("customer/selection").then(res => {
                this.optCustomer = res.data.data;
            });
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (this.filter.concert != null) {
                param += "&concert_id=" + this.filter.concert.id;
            }

            if (this.filter.destination !== -1) {
                param += "&destination=" + this.filter.destination;
            }

            if (this.filter.customer != null) {
                param += "&customer_id=" + this.filter.customer.id;
            }

            if (!this.$helper.isBlank(this.filter.start)) {
                param += "&start=" + this.filter.start;
            }

            if (!this.$helper.isBlank(this.filter.end)) {
                param += "&end=" + this.filter.end;
            }

            return this.$axios
                .get("concerts/deposits" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                    this.summary = res.data.data.summary;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        resetFilter() {
            this.filter = {
                concert: null,
                destination: -1,
                customer: null,
                start: "",
                end: ""
            };

            this.getItems();
        },

        getAttendanceBadgeVariant(status) {
            switch (status) {
                case ATTENDANCE_STATUS.PRESENT:
                    return "success";
                case ATTENDANCE_STATUS.ABSENT:
                    return "danger";
                default:
                    return "secondary";
            }
        },

        getDestinationBadge(item) {
            switch (item.destination) {
                case DEPOSIT_DESTINATION.AWAITING:
                    return { variant: "warning", label: "DP" };
                case DEPOSIT_DESTINATION.SETTLED:
                    return { variant: "success", label: "SETTLEMENT" };
                case DEPOSIT_DESTINATION.DONATED:
                    return { variant: "danger", label: "CSR" };
                case DEPOSIT_DESTINATION.REFUNDED:
                    if (item.refund && item.refund.status === REFUND_STATUS.CONFIRMED) {
                        return { variant: "success", label: "REFUND SELESAI" };
                    }
                    return { variant: "warning", label: "MENUNGGU REFUND" };
                default:
                    return { variant: "secondary", label: "-" };
            }
        },

        isCancelable(item) {
            if (!item) return false;
            return item.cancelable !== undefined
                ? Boolean(item.cancelable)
                : item.destination === DEPOSIT_DESTINATION.AWAITING;
        },

        cancelDp(item) {
            if (!item || !item.submission_id) return;

            let isConfirmed = confirm(
                `Batalkan SELURUH DP submission ini (${item.slot_count || 1} slot, Rp. ${this.$helper.formatThousand(
                    item.amount
                )})? Semua slot akan direfund.`
            );
            if (!isConfirmed) return;

            this.isBusy = true;
            this.$axios
                .post(`concerts/submissions/${item.submission_id}/cancel`)
                .then(() => {
                    this.$helper.toastSuccess(this, "DP berhasil dibatalkan.");
                    this.getItems(this.currentPage);
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        }
    },

    created() {
        this.init();
    }
};
</script>
